<voxel-container-md>
  <app-header (closeEvent)="onCloseEvent($event)"></app-header>
  <div class="voxel-container-md container-padding">
    
    <app-stepper 
          *ngIf="CONTENT_BOUNDS && stepsList && stepsList.length > 0" 
          [title]="CONTENT_BOUNDS?.title" 
          [currentStep]="3" 
          [stepsList]="stepsList" 
          [labelName]="CONTENT_BOUNDS?.name" 
          [labelStep]="CONTENT_BOUNDS?.step">
      </app-stepper> 

    <div class="container-data">

      <ng-container *ngIf="showErrorMessage">

        <div class="voxel-col-12">
          <voxel-alert [type]="CONTENT_BOUNDS?.error_notification?.type" light class="voxel-mb-2"
            [icon]="CONTENT_BOUNDS?.error_notification?.icon">
            {{this.CONTENT_BOUNDS?.error_notification?.text}}

            <button voxelButtonAction (click)="navigateTo('next')">
              {{this.CONTENT_BOUNDS?.error_notification?.link?.label}}
            </button>
          </voxel-alert>
        </div>
      </ng-container>

      <ng-container>
        <div class="voxel-row caption-text">
          <p class="voxel-col-12">{{this.CONTENT_BOUNDS?.caption_main}}</p>
        </div>
      </ng-container>

      <ng-container *ngIf="!isEditSectionContactsData && !isEditSectionInformationData">
        <ng-container *ngIf="isEditSectionBasicData else basicDataReadOnly">
          <app-form-solicitation-basic-data [formGroup]="basicDataForm" [data]="solicitationData?.basicData">
          </app-form-solicitation-basic-data>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!isEditSectionBasicData && !isEditSectionInformationData">
        <ng-container *ngIf="isEditSectionContactsData else contactsDataReadOnly">
          <app-form-solicitation-contacts-data [formGroup]="contactsDataForm" [data]="solicitationData?.contactsData">
          </app-form-solicitation-contacts-data>
        </ng-container>
      </ng-container>

      <ng-template #basicDataReadOnly>
        <div *ngIf="isVisible('customer_data')">
          <div class="card" *ngIf="CONTENT_BOUNDS?.sections?.basic_data; let section">
            <div class="card-title">
              <h4 class="">{{section?.title}}</h4>
              <div class="card-title-actions">

              </div>
            </div>
            <div class="card-content">
              <div class="voxel-row readonly-items" *ngIf="form.get('basic_data');let formBasic">
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.document_type?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="section?.controls?.document_type; let control">                    
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      control?.formControlName) | itemName:"id":"name":documentTypeList | unicode}}</span>                  
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.document_number?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="section?.controls?.document_number; let control">                  
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      control?.formControlName)}}</span>                    
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.client_names?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item">                  
                    <p class="readonly-item-title">{{section?.labels?.client_name}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      section?.controls?.client_names?.formControlName)}}
                      {{getValueProperty(solicitationData?.basicData,
                      section?.controls?.client_surnames?.formControlName)}}</span>
                  </div>
                </ng-container>                
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.state?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="section?.controls?.state; let control">                    
                      <p class="readonly-item-title">{{control?.label}}</p>
                      <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                        control?.formControlName) | itemName:"id":"name":departmentList }}</span>                    
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.city?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="section?.controls?.city; let control">                    
                      <p class="readonly-item-title">{{control?.label}}</p>
                      <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                        control?.formControlName) | itemName:"id":"name":citiesList }}</span>                    
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.address?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="section?.controls?.address; let control">                    
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      control?.formControlName)}}</span>                    
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.economic_activity?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="!customerExists && section?.controls?.economic_activity; let control">                    
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      control?.formControlName) | itemName:"id":"name":economicActivityList }}</span>                  
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.segment?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="customerExists && section?.controls?.segment; let control">                  
                  <p class="readonly-item-title">{{control?.label}}</p>
                  <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                    control?.formControlName) | itemName:"id":"name":segmentList }}</span>                 
                  </div>
                </ng-container>
                <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.subsegment?.formControlName)">
                  <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                    *ngIf="customerExists && section?.controls?.subsegment; let control">                  
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.basicData,
                      control?.formControlName) | itemName:"id":"name":subsegmentList }}</span>         
                  </div>
                </ng-container>               
                <div class="voxel-col-6 voxel-col-sm-4 voxel-col-md-6 readonly-item"
                  *ngIf="!isJuridicPerson && section?.controls?.gender; let control">
                  <ng-container *ngIf="getValueProperty(solicitationData?.basicData, section?.controls?.gender?.formControlName)">   
                    <div *ngIf="section?.controls?.gender?.not_implies_gender!==solicitationData?.basicData?.gender">                      
                      <p class="readonly-item-title">{{control?.label}}</p>
                      <span class="readonly-item-value"
                        [textContent]="getValueProperty(solicitationData?.basicData,control?.formControlName) | itemName:'id':'name':genderList"></span>                    
                    </div>
                  </ng-container>
                </div>
              </div>
              <div class="voxel-row readonly-items" *ngIf="CONTENT_BOUNDS?.sections?.contacts_data; let section">
                <div class="voxel-col-12">
                  <p class="datacontact-section">{{section?.labels?.contact_data}}</p>
                </div>
                <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.phone_1; let control">                
                  <p class="readonly-item-title">{{control?.label}}</p>
                  <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                    'contact_primary.phone_1', '')}}</span>                                    
                </div>
                <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.email; let control">                
                  <p class="readonly-item-title">{{control?.label}}</p>
                  <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                    'contact_primary.email', '')}}</span>                                    
                </div>  

                <ng-container *ngIf="isVisible('additional_contact')">
                  <div class="voxel-col-12">
                    <p class="datacontact-section">{{section?.labels?.contact_data_additional}}</p>
                  </div> 
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.names; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'contact_additional.names', '')}}</span>                                    
                  </div>
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.surnames; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'contact_additional.surnames', '')}}</span>                                    
                  </div>  
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.phone_1; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'contact_additional.phone_1', '')}}</span>                                    
                  </div>
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.email; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'contact_additional.email', '')}}</span>                                    
                  </div>  
                </ng-container>
                
                <ng-container *ngIf="isVisible('assigned_advisor')">
                  <div class="voxel-col-12">
                    <p class="datacontact-section">{{section?.labels?.comercial_contact}}</p>
                  </div> 
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.names; let control">                
                    <p class="readonly-item-title">{{section?.labels?.specialised_fullname}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'CA_Names', '')}} {{getValueProperty(solicitationData?.contactsData,
                      'CA_LastName', '')}}</span>                                    
                  </div>
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.CA_Email; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'CA_Email', '')}}</span>                                    
                  </div>  
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.CA_Phone; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'CA_Phone', '')}}</span>                                    
                  </div>
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.CA_Code; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'CA_Code', '')}}</span>                                    
                  </div> 
                  <div class="voxel-col-6 readonly-item" *ngIf="section?.controls?.CA_CodeProduct; let control">                
                    <p class="readonly-item-title">{{control?.label}}</p>
                    <span class="readonly-item-value">{{getValueProperty(solicitationData?.contactsData,
                      'CA_CodeProduct', '')}}</span>                                    
                  </div>    
                </ng-container>                            
              </div>              
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #contactsDataReadOnly>   
        <div>
          <div class="card" *ngIf="this.CONTENT_BOUNDS?.information_details let section">
            <div class="card-title">
              <h4 class="">{{section.title}}</h4>
              <div class="card-title-actions">
              </div>
            </div>
            <div class="card-content">
              <div class="voxel-row readonly-items">
                <div *ngIf="getValueProperty(solicitationData,'additionalData.CustomerTypes',false)"
                  class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                  <p class="voxel-text-body-01-bold" [innerText]="section?.clientType"></p>
                  <span class="voxel-text-body-01"
                    [innerText]="getValueProperty(solicitationData,'additionalData.CustomerTypes')|itemName:'id':'desc':customerTypesList"></span>
                </div>
                <div class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                  <p class="voxel-text-body-01-bold" [innerText]="section?.solicitationType"></p>
                  <span class="voxel-text-body-01"
                    [textContent]="getValueProperty(solicitationData,'additionalData.SolicitationType','')|itemName:'id':'name':celulaTypesList"></span>
                </div>
                <div class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                  <p class="voxel-text-body-01-bold">{{section?.solicitationSubType}}</p>
                  <span class="voxel-text-body-01"
                    [textContent]="getValueProperty(solicitationData,'additionalData.SolicitationSubtype','')|itemName:'id':'name':celulaSubtypesList"></span>
                </div>
                <div class="voxel-col-3 voxel-col-sm-4 voxel-col-md-6 readonly-item">
                  <p class="voxel-text-body-01-bold">{{section?.cellAssigned}}</p>
                  <span class="voxel-text-body-01"
                    [textContent]="getValueProperty(solicitationData,'additionalData.Cell.name','')"></span>
                </div>
                <div
                  class="voxel-col-12 voxel-col-4 voxel-border-color-soft voxel-border-small-top voxel-border-small-bottom voxel-pv-5">
                  <div class="voxel-row-4">
                    <div class="voxel-col-1">
                      <p class="voxel-text-body-01-bold" [textContent]="section?.value"></p>
                    </div>
                    <div class="voxel-col-2">
                      <span class="voxel-text-body-01"
                        [innerText]="getValueProperty(solicitationData,'additionalData.SolicitationValue','0')|currency:'COP':'$':'3.2-2':'es'"></span>
                    </div>
                  </div>
                </div>
                <div class="voxel-col-12">
                  <div class="voxel-col-12"
                    *ngIf="getValueProperty(solicitationData,'additionalData.additional_data', []).length>0">
                    <p class="voxel-col-12 voxel-text-body-01-bold">{{section?.supports}}</p>
                    <div class="voxel-row">
                      <voxel-list class="voxel-col-12">
                        <li voxelListColumn
                          *ngFor="let fileItem of solicitationData?.additionalData?.additional_data || []; let i = index;">
                          <voxel-list-text>
                            <button voxelButtonAction (click)="downloadFile(fileItem.file)">
                              {{fileItem.file.name}}
                            </button>
                          </voxel-list-text>
                          <voxel-list-descr><em>{{fileItem?.file?.size|fileSize}}</em>
                          </voxel-list-descr>
                        </li>
                      </voxel-list>
                    </div>
                  </div>
                  <div class="voxel-col-12"
                    *ngIf="getValueProperty(solicitationData, 'additionalData.Annotations', false)">
                    <p class="voxel-col-12 voxel-text-body-01-bold" [textContent]="section?.annotations??''"></p>
                    <span class="voxel-col-12 span-text"
                      [innerText]="getValueProperty(solicitationData, 'additionalData.Annotations')"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </ng-template>

      <ng-template #informationDataReadOnly *ngIf="false">
        <div class="card" *ngIf="CONTENT_BOUNDS?.sections?.additional_data; let section">
          <div class="card-title">
            <h4 class="">{{this.CONTENT_BOUNDS?.sections?.additional_data?.title}}</h4>
            <div class="card-title-actions">
              <!-- <voxel-icon class="ico" (click)="editSection(section?.id)">editar_outline</voxel-icon> -->
            </div>
          </div>
          <div class="card-content">

            <vcl-table class="voxel-col-sd-12 voxel-container-fluid">
              <table cdk-table [dataSource]="additionalData">
                <ng-container cdkColumnDef="date">
                  <th cdk-header-cell *cdkHeaderCellDef> Fecha de radicación </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.date}} </td>
                </ng-container>
                <ng-container cdkColumnDef="type">
                  <th cdk-header-cell *cdkHeaderCellDef> Tipo de solicitud </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.type}} </td>
                </ng-container>
                <ng-container cdkColumnDef="subtype">
                  <th cdk-header-cell *cdkHeaderCellDef> Subtipo de solicitud </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.subtype}} </td>
                </ng-container>
                <ng-container cdkColumnDef="document">
                  <th cdk-header-cell *cdkHeaderCellDef> Célula asignada </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.document}} </td>
                </ng-container>
                <ng-container cdkColumnDef="value">
                  <th cdk-header-cell *cdkHeaderCellDef> Valor </th>
                  <td cdk-cell *cdkCellDef="let element"> {{element.value | currency}} </td>
                </ng-container>
                <tr cdk-header-row *cdkHeaderRowDef="displayedColumnsInformation;"></tr>
                <tr cdk-row *cdkRowDef="let row; columns: displayedColumnsInformation;"></tr>
              </table>
            </vcl-table>

          </div>
        </div>


      </ng-template>
    </div>


    <div class="actions">

      <div class="voxel-row"
        *ngIf="!isEditSectionBasicData && !isEditSectionContactsData && !isEditSectionInformationData">
        <button *ngIf="!isLoading" voxelButton buttonStyle=secondary (click)="navigateTo('previous')"
          class="voxel-col-12 voxel-col-xs-2 voxel-col-offset-sm-2 voxel-col-sm-3 voxel-col-offset-md-3 voxel-col-md-4">
          {{this.CONTENT_BOUNDS?.buttons?.secondary_button?.caption}}
        </button>

        <button *ngIf="form && !isLoading" voxelButton (click)="navigateTo('next')"
          class="voxel-col-12 voxel-col-xs-2 voxel-col-sm-3 voxel-col-md-4" [disabled]="!form.valid">
          {{this.CONTENT_BOUNDS?.buttons?.primary_button?.caption}}
        </button>

        <voxel-loading-circle *ngIf="isLoading" class="loading voxel-col-12" [loadingTitle]="CONTENT_BOUNDS?.load_text"></voxel-loading-circle>

      </div>


      <div class="voxel-row"
        *ngIf="isEditSectionBasicData || isEditSectionContactsData || isEditSectionInformationData">
        <button voxelButton buttonStyle=secondary (click)="onCancelAction()"
          class="voxel-col-12 voxel-col-xs-2 voxel-col-offset-sm-2 voxel-col-sm-3 voxel-col-offset-md-3 voxel-col-md-4">
          {{CONTENT_BOUNDS?.buttons?.cancel_action_button?.caption}}
        </button>

        <button *ngIf="form" voxelButton (click)="onSaveAction()" class="voxel-col-12 voxel-col-xs-2 voxel-col-sm-3 voxel-col-md-4"
          [disabled]="!form.valid">
          {{CONTENT_BOUNDS?.buttons?.save_action_button?.caption}}
        </button>
      </div>

    </div>
  </div>

  <vcl-snack-bar></vcl-snack-bar>

  <button #defaultOriginDialogButtons="voxelOverlayOrigin" voxelOverlayOrigin class="no-visible"></button>

  <voxel-dialog [dialogOrigin]="defaultOriginDialogButtons" [id]="'dialog-b'" [buttonAlignment]="'horizontal'"
    [dialogIsOpen]="showDialogConfirm" (dialogClose)="dialogButtonClicked({type:''})">
    <p>Has terminado de diligenciar la información.</p>
    <p>¿Deseas radicar tu solicitud?</p>

    <div voxelDialogFooter>
      <button voxelButtonContextual (click)="dialogButtonClicked({type:'action1'})">
        Cancelar
      </button>
      <button voxelButtonContextual (click)="dialogButtonClicked({type:'action2'})">
        Aceptar
      </button>
    </div>

  </voxel-dialog>

</voxel-container-md>